import { endpoint, options, check } from '../helpers';

/**
 * User verifies the token value from the server
 *
 * @function
 */

const verifyToken = () => {
  fetch(endpoint('/verify-token'), options())
    .then(response => response.json())
    .then((response) => {
      if (!response.VerifyToken) check(null);
    })
    .catch(output => window.console.warn(output));
};

export default verifyToken;
